// FT-192 (REQ-07): подпись статьи платежа в таблицах платежей — «Статья · Подкатегория»
// (подкатегории нет — только статья). Одна логика для журнала компании, личной кассы,
// касс сотрудников и агентов: индекс подкатегорий по id строится один раз из дерева
// статей компании, а не перебором на каждую строку таблицы, поиска и экспорта.
import { companyCountCategories, subcategoryIndex, subcategoryLabel } from "@/utils/countCategory";

export default {
  computed: {
    // Подкатегории дерева статей компании по id (у филиала без дерева — пусто, подпись — только статья).
    subcategory_index() {
      const getters = (this.$store && this.$store.getters) || {};
      return subcategoryIndex(companyCountCategories(getters.getCompany, { fallback: true }));
    },
    // Перевод ключа одной ссылкой — подпись зовётся на каждую строку.
    translateKey() {
      return (key) => this.$t(key);
    },
  },
  methods: {
    countCategoryLabel(count) {
      return subcategoryLabel(count, this.subcategory_index, this.translateKey);
    },
  },
};
